export default __webpack_public_path__ + "media/images/home/living_booking-99bd1a9f281c9263259bf627c3afef1d.jpg";